import React, { useState } from "react";

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);

  // WhatsApp number with country code (India)
  const phone = "919897474108";

  // Helper to open WhatsApp with a prefilled message
  const openWhatsApp = (message) => {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    setOpen(false); // close menu after click
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 9999,
      }}
    >
      {/* ===== Program Menu (appears above the button) ===== */}
      {open && (
        <div
          style={{
            marginBottom: "12px",
            background: "#ffffff",
            borderRadius: "14px",
            boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
            overflow: "hidden",
            minWidth: "220px",
          }}
        >
          <div
            onClick={() =>
              openWhatsApp(
                "Hey! I want to enquire about the Equity Research program. Could you please share details?"
              )
            }
            style={menuItemStyle}
          >
            Equity Research
          </div>

          <div
            onClick={() =>
              openWhatsApp(
                "Hey! I want to enquire about the Fixed Income & Credit Analysis program. Could you please share details?"
              )
            }
            style={menuItemStyle}
          >
            Fixed Income
          </div>

          <div
            onClick={() =>
              openWhatsApp(
                "Hey! I want to enquire about the Quantitative Finance program. Could you please share details?"
              )
            }
            style={menuItemStyle}
          >
            Quantitative Finance
          </div>
        </div>
      )}

      {/* ===== WhatsApp Floating Button (Icon + Label) ===== */}
      <div
        onClick={() => setOpen((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          backgroundColor: "#25D366",
          padding: "12px 16px",
          borderRadius: "32px",
          cursor: "pointer",
          boxShadow: "0 8px 22px rgba(0,0,0,0.25)",
          userSelect: "none",
        }}
        title="Chat with us on WhatsApp"
      >
        {/* WhatsApp Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          fill="#ffffff"
          viewBox="0 0 24 24"
        >
          <path d="M12.04 0C5.42 0 .04 5.38.04 12c0 2.11.55 4.17 1.6 5.99L0 24l6.19-1.62A11.94 11.94 0 0 0 12.04 24c6.62 0 12-5.38 12-12S18.66 0 12.04 0zm0 21.96a9.93 9.93 0 0 1-5.04-1.38l-.36-.21-3.68.96.98-3.58-.23-.37a9.9 9.9 0 1 1 8.33 4.58z" />
        </svg>

        {/* WhatsApp Text Label */}
        <span
          style={{
            color: "#ffffff",
            fontSize: "0.95rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
            letterSpacing: "0.2px",
          }}
        >
          WhatsApp
        </span>
      </div>
    </div>
  );
};

// Shared style for menu items
const menuItemStyle = {
  padding: "12px 16px",
  fontSize: "0.9rem",
  cursor: "pointer",
  borderBottom: "1px solid #f0f0f0",
  backgroundColor: "#ffffff",
};

export default WhatsAppFloat;
